
<style lang="scss" scoped>

</style>

<template>
    <div>
        <div></div>
        <!-- 饼图、状柱图、折线图 -->
        <div class="clearfix margin-top-20" style="width:75%">
            <div style="display:flex;align-items:center;float:left;">
                <span>{{$t('fbb.analyze.costcomparetotal',{defaultValue:'费用概览'})}}:</span><vDatepicker v-model="month" format='yy-mm' ></vDatepicker>
            </div>
            <vButton class="pull-left margin-right-40" theme="primary" @click="getDetail(month)">{{$t('global.common.update_OK',{defaultValue:'确定'})}}</vButton>
            <div style="display:flex;align-items:center;">
                <vSelect style="width:130px" v-model="selectCost" @on-change="drawBar">
                    <vOption value=1>{{$t('fbb.billmanage.total_cost',{defaultValue:'总费用'})}}</vOption>
                    <vOption value=2>{{$t('fbb.analyze.base_cost',{defaultValue:'基础费用'})}}</vOption>
                    <vOption value=3>{{$t('fbb.analyze.additional_cost',{defaultValue:'附加费用'})}}</vOption>
                </vSelect>
            </div>

            <div id="BarGraph" style="height: 400px;margin-top:15px;" :key="index+1"></div>
        </div>

        <div class="clearfix margin-top-20" style="width:75%">
            <div id="pieGraph" style="height: 350px;"></div>
        </div>
    </div>
</template>

<script>
import { HttpAnalyzeCompare, HttpAnalyzeRange } from '@/service/fedex';
export default {
    data(){
        return {
            month:'',
            selectCost:1,
            nowyear:"",
            nowmonth:'',
            drawdata:'',
            index:0,
        }
    },
    created(){
        this.oneGet()
    },
    methods: {
        oneGet(){
            let nowdate = new Date();
            let seperator1 = "-";
            this.nowyear = nowdate.getFullYear();
            this.nowmonth = nowdate.getMonth() + 1;
            if (this.nowmonth >= 1 && this.nowmonth <= 9) {
                this.nowmonth = "0" + this.nowmonth;
            }
            let today = this.nowyear + '-' + this.nowmonth
            this.getDetail(today)
        },
        getDetail(val){
            if(val){
                this.month = val
            }
            HttpAnalyzeCompare({
                month:this.month 
            }).then(res=>{
                // console.log(res)
                this.drawdata = res.data
                this.selectCost = 1;
                this.drawBar()
            },err=>{

            })

            HttpAnalyzeRange({}).then(res=>{
                // console.log(res)
                this.drawPie(res.data)
            },err=>{

            })
        },
        // 柱状图----------------------------------
        drawBar(val){
            // console.log(333333)
            let dayarray = [],fedexAdden = [],fedexBase = [],costAdden = [],costBase = [],fedexTotal = [],costtotal = [];
            this.drawdata.map(item=>{
                dayarray.push(item.month);
                fedexAdden.push(item.comparisonItem.fedexAdden)
                fedexBase.push(item.comparisonItem.fedexBase)
                costAdden.push(item.comparisonItem.costAdden)
                costBase.push(item.comparisonItem.costBase)
                fedexTotal.push(item.comparisonItem.fedexTotal)
                costtotal.push(item.comparisonItem.costtotal)
            })
            let allarray = [fedexAdden,fedexBase,costAdden,costBase,fedexTotal,costtotal]
            // console.log(allarray)
            let BarGraph = Echarts.init(document.getElementById('BarGraph'));
            BarGraph.setOption({
                // top:50,
                title: {
                    text: this.$t('fbb.analyze.title6',{defaultValue:'费用对比概览--FedEx账单维度对比 （单位：USD）'}),
                    textStyle: {
                        fontSize: 16,
                        color: "#333",
                    },
                    subtext: this.$t('fbb.analyze.title7',{defaultValue:'数据说明：以FedEx账单结算月份数据为基准，对比云仓计算的费用'}),
                    subtextStyle: {
                        fontSize: 12,
                        color: '#333'
                    },
                },
                color: ['#ed3f14','#515a6e'],
                legend: {top:50,},
                tooltip : {},
                grid:{
                    top:100,
                },
                xAxis : {
                    name: this.$t('fbb.billmanage.bill_date',{defaultValue:'月份'}),
                    type : 'category',
                    data : dayarray,
                },
                yAxis: {
                    name: this.$t('fbb.analyze.cost',{defaultValue:'费用'})+'(USD)',
                    type: 'value',
                },
                series : [
                    {
                        name: this.$t('fbb.analyze.fedex_costorder',{defaultValue:'Fedex账单费用'}),
                        type: 'bar',
                        barWidth: '25%',
                        "label": {
                            "normal": {
                                "show": true,
                                "position": "top",
                                "formatter": "{c}"
                            }
                        },
                        data:val == 2 ? allarray[1] : val == 3 ? allarray[0] : allarray[4],
                    },
                    {
                        name: this.$t('fbb.analyze.cost_normal',{defaultValue:'成本费用'}),
                        type: 'bar',
                        barWidth: '25%',
                        "label": {
                            "normal": {
                                "show": true,
                                "position": "top",
                                "formatter": "{c}"
                            }
                        },
                        data:val == 2 ? allarray[3] : val == 3 ? allarray[2] : allarray[5],
                    },

                ]
            });

        },
        // 饼图--------------------------------------
        drawPie(data){
            var rich = {
                yellow: {
                    color: "#ffc72b",
                    fontSize: 20,
                    padding: [5, 4],
                    align: 'center'
                },
                white: {
                    color: "#333",
                    align: 'center',
                    fontSize: 14,
                    padding: [21, 0]
                },
                blue: {
                    color: '#49dff0',
                    fontSize: 16 ,
                    align: 'center'
                },
                hr: {
                    width: '100%',
                    borderWidth: 1,
                    height: 0,
                }
            }
            var m2R2Data= [
               {value:data.costBase, percent:data.costBaseRate, legendname:this.$t('fbb.analyze.base_cost',{defaultValue:'基础费用'}),name:this.$t('fbb.analyze.base_cost',{defaultValue:'基础费用'})+ data.costBase +" USD" + " (" + data.costBaseRate + "%)",itemStyle:{color:"#ff9900"}},
               {value:data.costAdden, percent:data.costAddenRate, legendname:this.$t('fbb.analyze.additional_cost',{defaultValue:'附加费用'}),name:this.$t('fbb.analyze.additional_cost',{defaultValue:'附加费用'})+ data.costAdden +" USD" + " (" + data.costAddenRate + "%)",itemStyle:{color:"#5cadff"}},
            ];
            let pieGraph = Echarts.init(document.getElementById('pieGraph'));
            
            pieGraph.setOption({
                title: [
                {
                    text: this.nowyear + this.$t('global.common.year',{defaultValue:'年'}) + this.nowmonth + this.$t('fbb.analyze.title8',{defaultValue:'月成本费用占比分析--云仓核算成本'}),
                    subtext: this.$t('fbb.analyze.title9',{defaultValue:'数据说明：云仓核算月份为基准计算的成本费用'}),
                    textStyle: {
                        fontSize: 16,
                        color: "#333",
                    },
                    subtextStyle: {
                        fontSize: 12,
                        color: '#333'
                    },
                    top:10,
                },    
                {
                    text: this.$t('erp.b2c.product_totalcount',{defaultValue:'合计'}),
                    subtext: data.costtotal + ' USD',
                    textStyle:{
                        fontSize:14,
                        color:"#333"
                    },
                    subtextStyle: {
                        fontSize: 16,
                        color: '#ed3f14'
                    },
                    textAlign:"center",
                    x: '34.5%',
                    y: '44%',
                }],
                tooltip: {
                    trigger: 'item',
                    formatter:function (parms){
                        // console.log(parms)
                    var str=  parms.seriesName+"</br>"+
                        parms.marker+""+parms.data.legendname+"</br>"+
                        this.$t('fbb.analyze.cost',{defaultValue:'费用'})+"："+ parms.data.value+"</br>"+
                        this.$t('fbb.analyze.proportion',{defaultValue:'占比'})+"："+ parms.data.percent+"%";
                        return  str ;
                    }
                },
                legend: {
                    type:"scroll",
                    orient: 'vertical',
                    left:'70%',
                    align:'left',
                    top:'middle',
                    textStyle: {
                        color:'#8C8C8C',
                        fontSize:14,
                        padding:10,
                    },
                    height:250,
                    
                },
                series: [
                    {
                        name:this.$t('fbb.billmanage.cost_detail',{defaultValue:'费用详情'}),
                        type:'pie',
                        center: ['35%', '50%'],
                        radius: ['48%', '65%'],
                        clockwise: false, //饼图的扇区是否是顺时针排布
                        avoidLabelOverlap: false,
                        label: {
                            normal: {
                                show: true,
                                position: 'outter',
                                fontSize:14,
                                formatter:function (parms){
                                    return '{white|' + parms.data.legendname + '}\n{yellow|' + parms.data.value +' USD' + '}\n{blue|' + parms.data.percent + '%}';
                                },
                                rich: rich
                            }
                        },
                        labelLine: {
                            normal: {
                            length:15,
                            length2:30,
                            smooth:true,
                            }
                        },
                        data:m2R2Data,
                        
                    }
                ]
            })
        },
    }
}
</script>

